import { isDefined } from "@omni/utils/helper.utils";

import { AddToCartProps } from "@/components/Modals/AddToCartModal/components/AddToCart/addToCart.container";

export const propsAreValid = (
    props: Partial<AddToCartProps>
): props is AddToCartProps => {
    return !!(
        props.sku &&
        props.title &&
        isDefined(props.boxArticle) &&
        isDefined(props.additionalService) &&
        isDefined(props.currentPrice) &&
        isDefined(props.promotions)
    );
};
